import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import toast from "react-hot-toast";

import Logo from "../components/Logo";
import { ArrowRight, ArrowLeft, Bug } from "lucide-react";

const PARENT_URL = "https://getkhojo.com";

const labelStyle = {
  display: "block",
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 1.5,
  textTransform: "uppercase",
  color: "var(--au-text-2)",
  marginBottom: 8,
};

export default function RegisterDebug() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const register = async () => {
    if (!name.trim() || !email.trim()) { toast.error("Both fields required"); return; }
    setBusy(true);
    try {
      await api.post("/api/auth/register", { name: name.trim(), email: email.trim() });
      toast.success("Account provisioned. Redirecting...");
      setTimeout(() => nav("/login"), 1200);
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div
      className="au-root"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: 20,
        position: "relative",
      }}
    >
      {/* Back to parent */}
      <a
        className="au-pill au-pill-glass au-pill-sm"
        href={PARENT_URL}
        style={{ position: "absolute", top: 24, left: 24, zIndex: 10 }}
      >
        <ArrowLeft size={16} /> Back
      </a>

      <div
        className="au-glass au-pad-lg"
        style={{ maxWidth: 440, width: "100%", position: "relative", zIndex: 5 }}
      >
        {/* Brand header */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <Logo size="large" />
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 3,
              textTransform: "uppercase",
              color: "var(--au-muted)",
              marginTop: 10,
            }}
          >
            New Operator Registration
          </div>
        </div>

        {/* Form */}
        <div className="au-marker" style={{ marginBottom: 10 }}>/ CREATE ACCOUNT</div>
        <h2 style={{ fontSize: 28, marginBottom: 24 }}>Get started</h2>

        <label htmlFor="register-name" style={labelStyle}>Operator Name</label>
        <input
          id="register-name"
          className="au-input"
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="John Doe"
          autoFocus
          style={{ marginBottom: 18 }}
        />

        <label htmlFor="register-email" style={labelStyle}>Email Address</label>
        <input
          id="register-email"
          className="au-input"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => e.key === "Enter" && !busy && register()}
          placeholder="user@domain.com"
          style={{ marginBottom: 20 }}
        />

        <button
          className="au-pill au-pill-primary"
          onClick={register}
          disabled={busy}
          style={{ width: "100%" }}
        >
          {busy ? "Provisioning…" : <>Create Account <ArrowRight size={18} /></>}
        </button>

        {/* Footer switch */}
        <div
          style={{
            marginTop: 24,
            paddingTop: 18,
            borderTop: "1px solid var(--au-hair)",
            fontSize: 13,
            color: "var(--au-muted)",
            textAlign: "center",
          }}
        >
          Already have an account?{" "}
          <Link
            to="/login"
            style={{ color: "var(--au-accent-ink)", textDecoration: "none", fontWeight: 600 }}
          >
            Sign in
          </Link>
        </div>
      </div>

      {/* Bottom credit */}
      <div
        style={{
          position: "absolute",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: 2,
          color: "var(--au-muted)",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <Bug size={13} style={{ color: "var(--au-accent-ink)" }} />
        Powered by{" "}
        <a
          href={PARENT_URL}
          style={{ color: "var(--au-accent-ink)", textDecoration: "none", fontWeight: 700 }}
        >
          GETKHOJO
        </a>
      </div>
    </div>
  );
}
